<template>
  <div v-title data-title="我的团队">
    <wv-tabs v-model="currentTab" @click="onClick">
      <wv-tab v-for="tab in tabs" :title="tab+'（'+TotalCount+'）'" :key="tab"></wv-tab>
    </wv-tabs>
    <wv-search-bar
      :autofocus="false"
      v-model="Keyword"
      @search="onSearch"
      @cancel="onCancel"
      :show="false"
      minContentHeight="0px"
      placeholder="请输入好友姓名"
    />
    <scroller
      :on-refresh="refresh"
      :on-infinite="infinite"
      style="padding-top: 90px;"
      ref="myScroller"
    >
      <div class="page" :class="borwser!=''?'':'needtomargin-top'">
        <div
          class="weui-form-preview preview-item"
          v-for="(model,$index) in orderlist"
          :key="$index"
        >
          <wv-media-box
            :title="model.Name"
            :thumb="model.HeadImgUrl"
            :description="'推广'+model.OrderCount+' 单，我赚'+model.Commission+'元'"
          ></wv-media-box>
          <span
            style="position: absolute;top: 66px;left: 85px; font-size:14px;color:#999"
          >注册时间：{{model.OperateTime}}</span>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";

export default {
  name: "myteam",
  data: function() {
    return {
      borwser: this.GLOBAL.borwser,
      LoginType: -1,
      FirstInit: true, //首次加载（加载分页防止重复请求）
      IsInitFinish:false,//初始化完毕
      logourl: thumb,
      Keyword: "",
      OrderType: null,
      ComboTypes: [],
      formset: [],
      PageSize: 5,
      PageNum: 1,
      TotalCount: "",
      orderlist: [],
      disType: 3,
      currentTab: 0,
      tabs: ["我的团队"]
    };
  },
  computed: {
    filterResult() {
      return this.defaultResult.filter(value =>
        new RegExp(this.value, "i").test(value)
      );
    }
  },
  created: function() {
    this.Initmyclient(0);
  },
  methods: {
    onShow() {
      console.log("shown");
    },
    onHide() {
      console.log("hidden");
    },
    onQueryShow() {
      console.log("onQueryShow");
    },
    onQueryHide() {
      console.log("onQueryHide");
    },
    Initmyclient: function(type) {
      var data = {
        Type: this.disType,
        Keyword: this.Keyword,
        PageSize: this.PageSize,
        PageNum: this.PageNum
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/login/getmydisinfopager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
            this.TotalCount = this.formset.Page.Total;
            this.IsInitFinish = true;
            if (type != 1) {
              this.orderlist = [];
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
            } else {
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
            }
          } else {
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
        });
    },

    onClick: function(index) {
      this.onSearch();
    },
    onSearch(val) {
      this.$store.commit("showLoading");
      this.PageNum = 1;
      // 自定义搜索处理
      this.Initmyclient(0);
    },
    onCancel(val) {
      // 自定义取消事件处理
    },

    //产品详情
    OrderDetail: function(guid) {
      if (this.OrderType == 1) {
        this.$router.push({
          path: "/page/orderdetail",
          query: {
            OrderGuid: guid
          }
        });
      }
    },

    refresh: function(done) {
      //下拉
      var self = this;
      setTimeout(function() {
        self.PageNum = 1;
        self.Initmyclient(0);
        done();
      }, 1500);
    },
    infinite: function(done) {
      var self = this;
      setTimeout(function() {
        if(!self.IsInitFinish)
        {
          setTimeout(self.infinite(done),1000);
        }else{
          if (self.FirstInit) {
            self.FirstInit = false;
            if (self.TotalCount == self.formset.List.length) {
              self.$refs.myScroller.finishInfinite(true);
              return;
            }
          }

          self.PageNum += 1;
          self.Initmyclient(1);
          done();
          if (self.formset.List.length == 0) {
            self.$refs.myScroller.finishInfinite(true);
            return;
          }
        }
      }, 1000);
    },
    btnClose: function() {}
  }
};
</script>




<style>
.combo-price {
  color: red;
  font-size: 1.17rem;
}
.combo-qi {
  font-size: 0.75rem;
  color: #999;
}
.wv-button {
  float: right;
  margin-right: 5%;
}
.weui-form-preview__hd {
  line-height: 1.5em;
  padding: 8px 15px;
}

.weui-media-box__date {
  float: right;
}

.weui-form-preview__btns {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: #3cc51f;
  display: block;
  flex: 1;
  position: relative;
}

.weui-media-box__content {
  text-align: right;
  float: right;
  width: 100%;
  font-size: 14px;
}

.fontsf {
  font-size: 14px;
  color: #000;
}

.fontsn {
  font-size: 14px;
}

.weui-form-preview__border {
  height: 10px;
  background-color: #efeff4;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 70px;
  font-size: 1.5rem;
}

.search_left_three {
  width: 33%;
  text-align: center;
  font-size: 0.9em;
  float: left;
  background-color: #fff;
}

.weui-cells {
  font-size: 14px;
  margin-top: 0px;
}
.weui-zdycolors {
  color: #999;
}
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
.red .weui-cell__ft {
  color: red;
}
.needtomargin-top-wx {
  padding-top: 40px;
}
.needtomargin-top-common {
  padding-top: 50px;
}
</style>




// WEBPACK FOOTER //
// src/components/mydisinfo/myteam.vue